import { Section, SectionHeading, Stagger, StaggerItem } from "@/components/Section";
import {
  Rocket,
  Workflow,
  Handshake,
  Repeat,
  ClipboardList,
  MessageSquare,
  Wallet,
  BarChart3,
  LayoutTemplate,
} from "lucide-react";

const FEATURES = [
  { icon: Rocket, title: "Program Deployment Engine", desc: "Turnkey deployment of curated programs — configured in days, not quarters." },
  { icon: Workflow, title: "Workflow Automation", desc: "Standardized flows across intake, vendor routing, fulfillment, and reconciliation." },
  { icon: Handshake, title: "Vendor Coordination Layer", desc: "Unified interface across specialized vendors and fulfillment partners." },
  { icon: Repeat, title: "Subscription Infrastructure", desc: "Native support for recurring plans, billing cycles, and retention triggers." },
  { icon: ClipboardList, title: "Intake & Onboarding", desc: "Configurable intake flows tuned per program, with minimal-PHI design." },
  { icon: MessageSquare, title: "Patient Engagement Automation", desc: "Automated touchpoints across onboarding, adherence, and renewal." },
  { icon: Wallet, title: "Financial Workflow Enablement", desc: "Invoice coordination, vendor payment workflows, ACH/card enablement." },
  { icon: BarChart3, title: "Analytics & Reporting", desc: "Program performance, MRR, adoption, and retention — in one view." },
  { icon: LayoutTemplate, title: "White-Label Funnels", desc: "Branded landing, intake, and conversion funnels per clinic." },
];

export default function PlatformOverview() {
  return (
    <Section testId="platform-overview-section" className="bg-white">
      <SectionHeading
        eyebrow="Platform Overview"
        title="From service to scalable program — fully operationalized."
        intro="A modular infrastructure stack that turns a curated service catalog into deployable, recurring-revenue programs."
      />

      <Stagger stagger={0.04}>
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {FEATURES.map((f, i) => (
            <StaggerItem key={f.title}>
              <div
                data-testid={`platform-feature-${i}`}
                className="group h-full rounded-2xl border border-slate-200 bg-slate-50/60 p-6 hover:bg-white hover:border-blue-200 transition-colors"
              >
                <div className="w-10 h-10 rounded-lg bg-white border border-slate-200 flex items-center justify-center group-hover:border-blue-200">
                  <f.icon className="w-4.5 h-4.5 text-slate-900" strokeWidth={1.8} />
                </div>
                <h3 className="mt-5 font-display text-base font-semibold text-slate-900">{f.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{f.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </div>
      </Stagger>
    </Section>
  );
}
